export default "__VITE_PUBLIC_ASSET__6d095d8f__"